export default [0.1, 0.3, 0.5, 0.7, 1, 1.2, 1.5, 2, 2.5, 3]
